import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import cityModel from "models/city.model";
import Select from "react-select";

import { Country, State, City } from "country-state-city";
import { ICountry, IState, ICity } from "country-state-city";
import statesModel from "models/states.model";
const AddCity = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState(null);
  const [selectedisoCode, setSelectedStateIsoCode] = useState(null);
  const [states, setStates] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [citiesOfSelectedState, setCitiesOfSelectedState] = useState([]);

  console.log(selectedCity, "selectedCity");

  useEffect(() => {
    // Fetching states on component mount
    const statesData = State.getStatesOfCountry("IN"); // Fetching Indian states
    // Mapping state data to react-select format
    const statesOptions = statesData.map((state) => ({
      label: state.name,
      value: state.name,
      isoCode: state.isoCode,
    }));
    setStates(statesOptions);
  }, []);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption.value);
    setSelectedStateIsoCode(selectedOption.isoCode);
    // Fetching cities of selected state
    const citiesData = City.getCitiesOfState("IN", selectedOption.isoCode);
    console.log("citiesData", citiesData); // Check if cities are fetched correctly
    const citiesOptions = citiesData.map((city) => ({
      label: city.name,
      value: city.name,
    }));
    console.log("citiesOptions:", citiesOptions); // Check if city options are created correctly
    setCitiesOfSelectedState(citiesOptions);
    setSelectedCity(""); // Reset selected city when state changes
  };


  const [cityState ,setCityState] = useState('')
  console.log(cityState, "cityState");


  const handleStateChangeinSelectState = (selectedOption) => {
    console.log("check iiii",selectedOption)
    setSelectedState(selectedOption.value);
    setCityState(selectedOption.id)
    const abbreviation = selectedOption?.value?.substring(selectedOption?.value?.length - 2);
    const abbreviations = selectedOption?.value?.split(' ')[2];
    // setSelectedStateIsoCode(selectedOption.isoCode);
    // Fetching cities of selected state
    const citiesData = City.getCitiesOfState("IN", abbreviation);
    console.log("citiesData", citiesData); // Check if cities are fetched correctly
    const citiesOptions = citiesData.map((city) => ({
      label: city.name,
      value: city.name,
    }));
    console.log("citiesOptions:", citiesOptions); // Check if city options are created correctly
    setCitiesOfSelectedState(citiesOptions);
    setSelectedCity(""); // Reset selected city when state changes
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption.value);
  };

  const handleSubmitCity = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("name", selectedCity);
    form.append("state", cityState);
    // You can adjust the header configuration according to your API requirements
    cityModel
      .createCity(form)
      .then((response) => {
      
        helper.sweetalert.toast("Your City add.", "success");
        navigate("/admin/city");
        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
     
      });
  };

 

  const [dataListState, setDataListState] = useState([]);
  const getListData = async () => {
    await statesModel
      .listState()
      .then((result) => {
        if (result) {
          setDataListState(result?.results);
        }
      })
      .catch((error) => {
        // helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  useEffect(() => {
    getListData();
  }, []);

  console.log(dataListState, "dataListState");
  console.log(states, "states");

  const params = useParams();
  const transformedOptions =
    dataListState &&
    dataListState?.map((item) => ({
      value: item?.name,
      label: item?.name,
      id : item?.id
    }));
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add {params.name}</h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitCity}>
                  
                  <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="stateSelect">State</Label>
                            <Select
                              id="stateSelect"
                              value={{
                                label: selectedState,
                                value: selectedState,
                                // isoCode: selectedState,
                              }} // Make sure selectedState is an object with value and label properties
                              onChange={handleStateChangeinSelectState}
                              options={transformedOptions}
                              placeholder="Select State"
                              isSearchable={true} // Enable searching within dropdown
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="citySelect">City</Label>
                            <Select
                              id="citySelect"
                              // name="citySelect"
                              value={{
                                label: selectedCity,
                                value: selectedCity,
                              }}
                              onChange={handleCityChange}
                              options={citiesOfSelectedState}
                              placeholder="Select City"
                              isSearchable={true} // Enable searching within dropdown
                            />
                          </FormGroup>
                        </Col>{" "}
                      </Row>

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/city" tag={Link}>
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                         
                          type="submit"
                          style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddCity;
